declare namespace $ {

	type $mol_paragraph__title_easyreels_user_recordings_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__Empty_easyreels_user_recordings_2 = $mol_type_enforce<
		ReturnType< $easyreels_user_recordings['Empty'] >
		,
		ReturnType< $mol_list['Empty'] >
	>
	type $mol_list__rows_easyreels_user_recordings_3 = $mol_type_enforce<
		ReturnType< $easyreels_user_recordings['rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_paragraph__title_easyreels_user_recordings_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $easyreels_user_recording__recording_easyreels_user_recordings_5 = $mol_type_enforce<
		ReturnType< $easyreels_user_recordings['row'] >
		,
		ReturnType< $easyreels_user_recording['recording'] >
	>
	export class $easyreels_user_recordings extends $mol_view {
		Empty( ): $mol_paragraph
		rows( ): readonly($mol_view)[]
		List( ): $mol_list
		row( id: any): any
		used_bytes( ): number
		limit_bytes( ): number
		sub( ): readonly(any)[]
		Pending( ): $mol_paragraph
		Item( id: any): $easyreels_user_recording
	}
	
}

//# sourceMappingURL=recordings.view.tree.d.ts.map